import { useAuth } from '@cmg/auth';

import { hasOfferingDetailsPermissions } from '../OfferingRoute.model';

export function useHasOfferingAccess() {
  const { userPermissions } = useAuth();
  return hasOfferingDetailsPermissions(userPermissions);
}
